import { render } from "./ProductsImportAssistant.vue?vue&type=template&id=c3bdff9e&scoped=true"
import script from "./ProductsImportAssistant.vue?vue&type=script&lang=js"
export * from "./ProductsImportAssistant.vue?vue&type=script&lang=js"

import "./ProductsImportAssistant.vue?vue&type=style&index=0&id=c3bdff9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3bdff9e"]])

export default __exports__